import { ref } from 'vue'
import type { Conversation } from '@/types/dashboard'

export interface FloatWindow {
  uid: string
  conv: Conversation
  x: number
  y: number
  w: number
  h: number
  z: number
  minimized: boolean
}

const windows = ref<FloatWindow[]>([])
let nextZ = 1000

export function useFloatChats() {
  function open(conv: Conversation) {
    const existing = windows.value.find(w => w.conv.id === conv.id)
    if (existing) {
      existing.minimized = false
      existing.z = ++nextZ
      return
    }
    const count = windows.value.filter(w => !w.minimized).length
    const offset = (count % 6) * 28
    windows.value.push({
      uid: `fc-${conv.id}`,
      conv,
      x: Math.max(40, window.innerWidth - 440 - offset),
      y: 100 + offset,
      w: 380,
      h: 530,
      z: ++nextZ,
      minimized: false,
    })
  }

  function close(uid: string) {
    windows.value = windows.value.filter(w => w.uid !== uid)
  }

  function closeAll() {
    windows.value = []
  }

  function bringToFront(uid: string) {
    const w = windows.value.find(w => w.uid === uid)
    if (w) w.z = ++nextZ
  }

  function updateConv(conv: Conversation) {
    const w = windows.value.find(w => w.conv.id === conv.id)
    if (w) w.conv = conv
  }

  return { windows, open, close, closeAll, bringToFront, updateConv }
}
